export {default as AboutUs} from './aboutUs'



// WEBPACK FOOTER //
// ./src/components/aboutUs/index.js